import addClassRoomTemplate from './../../settings/add-class-room/add-class-room.html';
import template from './school-classes.html';

class SchoolClassesComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    ClassRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.ClassRoomService = ClassRoomService;

    this.selectedClassRoom = {};
    this.columnKeys = ['name'];
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  assignClassRoom() {
    this.ClassRoomService
      .assignClassRoom(this.selectedClassRoom)
      .then(() => {
        this.selectedClassRoom = {};
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano salę do świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(errorMessage => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(errorMessage)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  addClassRoom(ev) {
    this.ClassRoomService.getUnassignedClassRooms().then(result => {
      this.unassignedClassRooms = result;
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'AddClassRoomController',
        template: addClassRoomTemplate,
        clickOutsideToClose: true,
        locals: {classRooms: this.unassignedClassRooms},
        targetEvent: ev
      })
        .then(() => {
          this.ClassRoomService.getUnassignedClassRooms().then(result => {
            this.unassignedClassRooms = result;
          });
        }, () => {});
    });
  }

  removeClassRoom(assignedClassRooms) {
    this.ClassRoomService.deleteClassRoom(assignedClassRooms)
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto salę ze świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const SchoolClasses = {
  bindings: {
    unassignedClassRooms: '<',
    assignedClassRooms: '<',
    me: '<'
  },
  template,
  controller: SchoolClassesComponent
};
